import React from 'react';

import Utilities from './Utilities.jsx';

function Arrow(props) {
    const style = {};
    Utilities.copyObject(props.style, style);
    switch (props.direction) {
        case 'next':
            style.right = props.offset;
            break;
        case 'prev':
            style.left = props.offset;
            break;
    }
    return <span className={`carousel__arrows carousel__arrows__${props.direction}`} style={style} onClick={() => props.onClick && props.onClick(props.direction)} />
}

export default Arrow;